export default __webpack_public_path__ + "static/media/Background_00267.7ee4a04d.png";